module.exports = __webpack_public_path__ + "cfb36ddbdf4346d7a7a06022a7bad116.svg";